import ValidationResult from "domain/types/global/validationResult";

export const RECUPERAR_SENHA = 'RECUPERAR_SENHA';

export interface RecuperarSenhaState {
    validationResult: ValidationResult | null;
}

export interface RecuperarSenhaAction {
    type: typeof RECUPERAR_SENHA;
    payload: ValidationResult;
}

export type RecuperarSenhaActionTypes = RecuperarSenhaAction;